import { get } from "lodash";
import { type StandardBiological, type StandardFertiliser } from "../types";

export const populateRatesDosage = (
  trialPlotData: any,
  activeKey: string[],
  existingRates: any,
  unit?: string,
  standardSeedRate?: number,
  standardProduct?: string,
  standardSeedProductId?: string,
  standardfertilisers?: StandardFertiliser[],
  standardBiologicalApplicationSettings?: StandardBiological[],
  standardTankMixRates?: number[]
): any => {
  const ratesAndDosages: any = [];

  const formattedData = trialPlotData?.map((item: any) => {
    const biologicals = item?.properties?.biologicals || null;
    if (biologicals) {
      const { treatments } = biologicals;
      const transformedTreatments = treatments?.[0]?.map(
        (_: any, colIndex: number) =>
          treatments?.map((row: any) => row[colIndex])
      );
      return {
        ...item,
        properties: {
          ...item?.properties,
          biologicals: {
            ...biologicals,
            treatments: transformedTreatments || [],
          },
        },
      };
    }
    return item;
  });

  formattedData?.forEach((trialPlot: any, index: number) => {
    const ratesForPlotsAndReplicants: any = [];
    const { id, rows, columns } = trialPlot?.plot;
    const dataAlreadyFilledSeeds = get(
      trialPlot,
      "properties.seeds.rates_and_dosages",
      []
    );

    const dataAlreadyFilledBiologicals = get(
      trialPlot,
      "properties.biologicals.treatments",
      []
    ).map((obj: any) => {
      return {
        bioTreatement: obj,
      };
    });

    const dataAlreadyFilledNutrients = get(
      trialPlot,
      "properties.fertilisers.rates_and_dosages",
      []
    ).map((obj: any) => {
      return {
        fertiliser_rate: obj?.rate,
        fertiliser_amount: Number(obj?.amount ?? 0),
      };
    });

    const existtingFilledDaata =
      [
        dataAlreadyFilledSeeds,
        dataAlreadyFilledBiologicals,
        dataAlreadyFilledNutrients,
      ]?.find((arr) => arr.length > 0) || [];

    const mergedData = existtingFilledDaata?.map(
      (seedData: any, index: number) => {
        const biologicalData = dataAlreadyFilledBiologicals[index];
        const nutrientData = dataAlreadyFilledNutrients[index];
        return { ...seedData, ...biologicalData, ...nutrientData };
      }
    );

    const existingPlotRates = existingRates?.[index];
    const hasExistingValues = existingPlotRates?.some(
      (entry: any) =>
        Boolean(entry?.variety?.trim?.()) ||
        Number(entry?.rate) > 0 ||
        Number(entry?.fertiliser_rate) > 0 ||
        Number(entry?.fertiliser_amount) > 0 ||
        entry?.bioTreatement?.some(
          (treatment: any) =>
            treatment?.treated === true ||
            treatment?.selected_treatment?.length > 0
        )
    );
    const existingRD =
      existingPlotRates?.length === rows * columns &&
      (hasExistingValues === true || mergedData.length === 0)
        ? existingPlotRates
        : mergedData;

    if (existingRD?.length === rows * columns) {
      const allPlotIds: string[] = [];
      // Set the plot_id as it is not storing in DB
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < columns; col++) {
          const plotId = `${id as number}-${row}-${col}`;
          allPlotIds.push(plotId);
        }
      }
      ratesAndDosages?.push(
        existingRD?.map((e: any, i: number) => {
          return { ...e, plot_id: allPlotIds[i], collapseValue: activeKey };
        })
      );
    } else {
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < columns; col++) {
          const plotId = `${id as number}-${row}-${col}`;

          ratesForPlotsAndReplicants.push({
            plot_id: plotId,
            rate: 0,
            variety: "",
            collapseValue: activeKey,
            fertiliser_rate: 0,
            fertiliser_amount: 0,
          });
        }
      }
      ratesAndDosages.push(ratesForPlotsAndReplicants);
    }
  });

  const result = {
    rates_and_dosages: ratesAndDosages,
    type: "seeds",
    unit_of_rate: unit, // TODO: Check if this is correct
    standard_seed_rate: standardSeedRate,
    standard_product: standardProduct,
    standard_seed_product_id: standardSeedProductId,
    standard_fertilisers: standardfertilisers,
    standard_biological_application_settings:
      standardBiologicalApplicationSettings,
    standard_tank_mix_rates: standardTankMixRates,
  };

  return result;
};

export default populateRatesDosage;
